import {
  NamedColor,
  NamedIconButtonColor,
  NamedIconColor,
  NamedSize,
} from '../types'

export const isNamedColor = (color: string): color is NamedColor => {
  return [
    'inherit',
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning',
  ].includes(color)
}

export const isNamedIconColor = (color: string): color is NamedIconColor => {
  return isNamedColor(color) || ['action', 'disabled'].includes(color)
}

export const isNamedIconButtonColor = (
  color: string
): color is NamedIconButtonColor => {
  return isNamedColor(color) || ['default'].includes(color)
}

export const isNamedSize = (size: string | number): size is NamedSize => {
  if (typeof size === 'number') {
    return false
  }
  return ['inherit', 'small', 'medium', 'large'].includes(size)
}

export const namedSizeToNumber = (
  size: NamedSize | number | undefined
): number | undefined => {
  switch (size) {
    case 'inherit':
      return undefined

    case 'small':
      return 20

    case 'medium':
      return 24

    case 'large':
      return 35

    default:
      return size
  }
}
